export const sunColourMap = {
    sunrise: "orange",
    sunset: "orange",
    day: "#FFFF00",
    night: "orange",
};

export const gradients = {
    sunrise: ["#373658", "#da7789"],
    day: ["#87CEEB", "#87CEEB"],
    sunset: ["#023d68", "#f1629e"],
    night: ["#14155d", "#757F9A"],
}



// WEBPACK FOOTER //
// ./src/modules/colors-and-stuff.js